import {
    REQUEST_USAGE_INDICATORS,
    RECEIVE_USAGE_INDICATORS,
    RECEIVE_USAGE_INDICATORS_ERROR
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    isFetching: false,
    deviceBasedIndicators: {},
    performanceBasedIndicators: {},
    historicalBasedIndicators: {},
    compiledIndicators: {},
    reportAvailability: {}
};

const requestUsageIndicators = (state) => {
    return {
        ...state,
        isFetching: true
    };
};

const receiveUsageIndicators = (isSuccess) => (state, action) => {
    if (!isSuccess) {
        return {
            ...state,
            isFetching: false,
            deviceBasedIndicators: {},
            performanceBasedIndicators: {},
            historicalBasedIndicators: {},
            compiledIndicators: {},
            reportAvailability: {},
            lastUpdated: action.receivedAt
        };
    }

    const compiledIndicators = state.compiledIndicators || {};

    const compiledDeviceBasedIndicators = {
        ...action.data.deviceBasedIndicators,
        ...action.data.historicalDeviceBasedIndicators
    };

    // mark any indicator as true if a deviceBasedIndicator or historicalIndicator is true, false otherwise
    Object.keys(compiledDeviceBasedIndicators).forEach((indicatorString) => {
        compiledIndicators[indicatorString] =
            action.data.deviceBasedIndicators[indicatorString] ||
            action.data.historicalDeviceBasedIndicators[indicatorString];
    });

    return {
        ...state,
        isFetching: false,
        deviceBasedIndicators: action.data.deviceBasedIndicators,
        performanceBasedIndicators: action.data.performanceBasedIndicators,
        historicalBasedIndicators: action.data.historicalDeviceBasedIndicators,
        compiledIndicators: compiledIndicators,
        reportAvailability: action.data.ReportAvailability,
        lastUpdated: action.receivedAt
    };
};

const handlers = {
    [REQUEST_USAGE_INDICATORS]: requestUsageIndicators,
    [RECEIVE_USAGE_INDICATORS]: receiveUsageIndicators(true),
    [RECEIVE_USAGE_INDICATORS_ERROR]: receiveUsageIndicators(false)
};

export const isUsageIndicatorsFetching = (state) => {
    return state.usageIndicators.isFetching;
};

export const getDeviceBasedIndicators = (state) => {
    return state.usageIndicators.deviceBasedIndicators;
};

export const getPerformanceBasedIndicators = (state) => {
    return state.usageIndicators.performanceBasedIndicators;
};

export const getCompiledIndicators = (state) => {
    return state.usageIndicators.compiledIndicators;
};

export const getHistoricalBasedIndicators = (state) => {
    return state.usageIndicators.historicalBasedIndicators;
};

export const getReportAvailability = (state) => {
    return state.usageIndicators.reportAvailability;
};

export default function usageIndicators(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

/*
 * @param state: store state
 * @param indicatorsToCheck: array of indicator names to return (optional, returns full list if not provided)
 * @returns an object of indicators from the historical indicators
 */
export function checkHistoricalIndicators(state, indicatorsToCheck) {
    let retVal = {};

    if (state.usageIndicators.historicalBasedIndicators) {
        if (indicatorsToCheck) {
            for (let i = 0; i < indicatorsToCheck.length; i++) {
                retVal[indicatorsToCheck[i]] = state.usageIndicators.historicalBasedIndicators[indicatorsToCheck[i]]
                    ? state.usageIndicators.historicalBasedIndicators[indicatorsToCheck[i]]
                    : false;
            }
        } else {
            retVal = state.usageIndicators.historicalBasedIndicators;
        }
    }

    return retVal;
}
